define('responsive-gameday/views/render/PlayByPlayViewRender',['require','exports','module','./ViewRender','Wax/get!view-templates/playByPlay/playByPlay','Wax/get!view-templates/linescore/embeddedLinescore'],function(require,exports,module){
    var ViewRender = require('./ViewRender'),
        Superclass;

    function PlayByPlayViewRender(){
        Superclass.constructor.call(this,
            require('Wax/get!view-templates/playByPlay/playByPlay'),{
                embeddedLinescoreView   : require( 'Wax/get!view-templates/linescore/embeddedLinescore' )
            }
        );
    }
    ViewRender.spawn(PlayByPlayViewRender);

    Superclass=PlayByPlayViewRender.superclass;

    return PlayByPlayViewRender;
});
